import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MenuItem, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { InventoryService } from '../../../services/inventory.service';
import _ from 'lodash';
import { AdministratorService } from '../../../services/administrator.service';
import { Color, GSTInfo, Product, gridPageRequest } from '../../../model/common/common.model';
import { LoaderComponent } from '../../loader/loader.component';
import { color, ProductGroups, UnitsOfMeasure } from '../../../model/administration.model';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { GstListLookupComponent } from '../../Lookup/gst-list-lookup/gst-list-lookup.component';
import { InventoryStatusLookupComponent } from '../../Lookup/inventory-status-lookup/inventory-status-lookup.component';
import { LedgerLookupComponent } from '../../Lookup/ledger-lookup/ledger-lookup.component';
import { VendorLookupComponent } from '../../Lookup/vendor-lookup/vendor-lookup.component';
import { ProductLocationsLookupComponent } from '../../Lookup/product-locations-lookup/product-locations-lookup.component';
import { vendor } from '../../../model/masters.model';
import { catchError, forkJoin, of } from 'rxjs';
@Component({
  selector: 'app-create-products',
  standalone: true,
  imports: [SharedModule, CommonModule, LoaderComponent],
  providers: [MessageService],
  templateUrl: './create-products.component.html',
  styleUrl: './create-products.component.scss'
})
export class CreateProductsComponent implements OnInit {
  @ViewChild('fileInput') fileInput!: ElementRef;
  productId: any;
  isReset: any;
  resetClicked = false;
  selectedStandardType: any;
  constructor(private messageService: MessageService, private router: Router, private sanitizer: DomSanitizer, private inventoryService: InventoryService,
    private route: ActivatedRoute, private administratorService: AdministratorService, public dialogService: DialogService, public ref: DynamicDialogRef) { }

  activeIndex: number = 0;
  loader: boolean = false;
  RoleId: number = 0;
  iseditProduct: boolean = false;
  editProductData: any;
  submitted: boolean = false;
  value: string = '';
  Attributes: any[] = [];
  saveImage: Blob | undefined;
  isManual: boolean = false;
  deletedImage: string | undefined;
  gstRate: number | null = null;
  hide: boolean = false;
  allHSNCodes: any[] = [];
  filteredHSNCodes: any[] = [];
  selectedFile: File | null = null;
  previewImage: string | null = null;
  vendorState: string | undefined;
  warehouseState: string | undefined;
  ShipTocustomerList: any[] = [];
  selectedCustomerEmail: string | null = null;
  selectedCustomerName: string | null = null;
  moreMenuItems: MenuItem[] = [];

  product: Product[] = [];
  vendor: vendor[] = [];

  isAutoProductCodeEnabled = false;
  isConfigLoaded = false;

  createProductForm = new FormGroup({
    ProductId: new FormControl(0),
    ProductName: new FormControl('', Validators.required),
    //ProductCode: new FormControl('', [Validators.required, Validators.pattern(/^[a-zA-Z0-9]*$/)]),
    ProductCode: new FormControl('', Validators.required),
    ProductDescription: new FormControl(''),
    ProductImage: new FormControl(),
    // CheckBox
    CanBeSold: new FormControl(false),
    CanBePurchased: new FormControl(false),
    CanBeRented: new FormControl(false),
    isactive: new FormControl(true, Validators.requiredTrue),
    IsTaxable: new FormControl(true),
    isLotTracking: new FormControl(false),
    IsInventory: new FormControl(true),
    isLocationTracking: new FormControl(false),
    isSerialTracking: new FormControl(false),
    // General Information
    ProductType: new FormControl('', Validators.required),
    producttypedropdown: new FormControl(''),
    UOM: new FormControl(''),
    UnitsofMeasureId: new FormControl(null),
    UnitsOfMeasure: new FormControl('', Validators.required),
    PurchasingUom: new FormControl(""),
    SellingUom: new FormControl(""),
    SalesPrice: new FormControl(0.00),
    StandardCost: new FormControl(0.00),
    Weight: new FormControl(0),
    CategoryId: new FormControl(0), //Product Category
    // Category: new FormControl(''),
    CategoryValue: new FormControl(''),
    // SubCategoryId: new FormControl(''), //Product Category
    // SubCategory: new FormControl(''), //Product Category
    // Sales
    // GST: new FormControl(''),
    // Inventory
    GSTId: new FormControl(),
    gstRate: new FormControl(),
    make: new FormControl(),
    mkfpartid: new FormControl(),
    productcomment: new FormControl(),
    HSNCode: new FormControl(),
    Barcode: new FormControl(''),
    CreatedBy: new FormControl(''),
    UpdatedBy: new FormControl(),
    CostCalculation: new FormControl(),
    manualEntry: new FormControl(false),
    Vendor: new FormControl(),
    VendorName: new FormControl(''),
    VendorCode: new FormControl(),
    Add: new FormControl(),
    AddressId: new FormControl(),
    ProductSpecification: new FormControl(),
    ProductSize: new FormControl(),
    VendorId: new FormControl(),

    ColorId: new FormControl<number | null>(null),
    ColorName: new FormControl<any>(null),
    Color: new FormControl<Color | null>(null),
    GroupId: new FormControl<any>(null),
    SubCategoryId: new FormControl<any>(null),
    ProductGroupName: new FormControl(null, Validators.required),
    SubCategoryName: new FormControl(null),
    VendorProductCode: new FormControl(null),
    StandardType: new FormControl(),
    IsServiceType: new FormControl<boolean | null>(null, Validators.required),
    ProductPrefix: new FormControl(''),
  });

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 100,
    id: 0
  }

  UOMDropdown: UnitsOfMeasure[] = [];
  ColorDropdown: Color[] = [];
  filteredColors: Color[] = [];
  //filtercolor: Color[] = [];
  selectedColor?: Color;
  // ColorDropdown: color[] = [];
  // filtercolor: color[] = [];
  ProductGroupsDropdown: ProductGroups[] = [];
  filterProductGroups: ProductGroups[] = [];
  filteruom: UnitsOfMeasure[] = [];
  ProductTypeDropdown: any[] = [];
  ProductSubCategoryDropdown: any[] = [];
  filterProductSubCategory: any[] = [];
  CategoryDropdown: any[] = [];
  filterCategorys: any[] = [];
  filterproducttype: any[] = [];
  GSTList: GSTInfo[] = [];

  unitLabel: string = '';
  manualEntryChecked: boolean = false;

  ngOnInit(): void {
    document.title = 'Create Product';
    this.createProductForm.controls.CreatedBy.setValue(localStorage.getItem('username'));
    this.route.queryParams.subscribe(params => {
      if (params['productId']) {
        this.iseditProduct = true;
      }

      this.EditProduct();
      this.getProductCodeSetting();
    });
    //this.EditProduct();
    //   this.getColor().then(() => {
    //   this.EditProduct();
    // });
    this.getUOM();
    this.getProductType();
    this.getCatagory();
    this.getProductGroups();
    // this.getColor();
    this.getProductSubCategory();
    // this.getSystemConfigData();
    this.moreMenuItems = [
      {
        label: 'Inventory Status',
        command: () => this.showInventoryStatus(),
      },
      {
        label: 'Ledger',
        command: () => this.showLedger(),
      },
      {
        label: 'Locations',
        command: () => this.showLocations(),
      },
    ];

    this.createProductForm.get('ProductType')?.valueChanges.subscribe(value => {
      this.updateFieldValidators(value || '');
    });

    const currentProductType = this.createProductForm.get('ProductType')?.value;
    this.updateFieldValidators(currentProductType || '');

    this.inventoryService.getUnitByAppKey('unitNameLabel')
      .subscribe((res: any) => {
        this.unitLabel = res?.data || 'Unit';
      });
  }

  getProductCodeSetting() {
    this.inventoryService
      .getUnitByAppKey('hide.Product_type')
      .subscribe((res: any) => {

        this.isAutoProductCodeEnabled = res?.data === 'Y';

        this.createProductForm.patchValue({
          manualEntry: false
        });

        if (this.iseditProduct) return;

        this.generateProductCode();
      });
  }

  generateProductCode() {
    if (this.iseditProduct) return;

    if (this.isAutoProductCodeEnabled) {
      this.getManualEntry();
      this.createProductForm.controls.ProductCode.setValue("");
    } else {
      this.getProductCode();
    }
  }

  generateCode() {
    if (this.isAutoProductCodeEnabled) {
      this.getManualEntry();
    } else {
      this.getProductCode();
    }
  }

  manualEntry() {
    if (this.iseditProduct) return;

    const isManual = this.createProductForm.controls.manualEntry.value;

    if (isManual) {
      this.createProductForm.controls.ProductCode.reset();
      return;
    }

    this.generateProductCode();
  }

  getManualEntry() {
    const productType = this.createProductForm.controls['ProductType'].value;
    const prefix = this.createProductForm.controls['ProductPrefix'].value ?? '';

    if (!productType) return;

    this.getAutoProductCode(prefix);
  }

  getProductCode() {
    this.inventoryService.autogenerateProductCodeNew().subscribe({
      next: (data: any) => {
        // console.log(data.productCode);

        // const alphanumericCode = 'P';
        // const productCode = alphanumericCode + data;
        // this.createProductForm.controls.ProductCode.setValue(productCode);
        this.createProductForm.controls.ProductCode.setValue(data.productCode);
      },
      error: error => {
        console.log(error);
      }
    });
  }


  checkProductCode() {
    const productCode = this.createProductForm.controls.ProductCode.value;
    if (!productCode) {
      this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Please enter a product code' });
      return;
    }
    if (!this.iseditProduct) {
      this.inventoryService.checkProductCode(productCode).subscribe(
        (data: any) => {
          if (data.success) {
            if (data.product) {
              if (data.product.isActive === 1) {
                this.createProductForm.controls.ProductCode.setValue('');
                this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Product code already exists and is active' });
              } else if (data.product.isActive === 0) {
                this.createProductForm.controls.ProductCode.setValue('');
                this.messageService.add({
                  severity: 'warn',
                  summary: 'Inactive Product Code',
                  detail: 'This product code is inactive. You cannot create a new product using this code. You may want to update the existing product instead.'
                });
              }
            }
          } else {
            this.createProductForm.controls.manualEntry.setValue(true);
          }
        },
        (error: any) => {
          console.log(error);
          this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'There was an error checking the product code' });
        }
      );
    }
  }



  get formControls() {
    return this.createProductForm.controls;
  }

  updateFieldValidators(productType: string) {
    const salesPriceControl = this.createProductForm.get('SalesPrice');
    const standardCostControl = this.createProductForm.get('StandardCost');

    if (productType === 'FG1112') {
      salesPriceControl?.clearValidators();
      standardCostControl?.clearValidators();
    } else {
      salesPriceControl?.setValidators([Validators.required]);
      standardCostControl?.setValidators([Validators.required]);
    }
    salesPriceControl?.updateValueAndValidity();
    standardCostControl?.updateValueAndValidity();
  }


  validateForm() {
    let isValid = true;
    if (this.createProductForm.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please fill Required fields' });
      isValid = false;
    }

    return isValid;
  }

  // onFileSelected(event: any) {
  //   if(event){
  //     const file = event.target.files[0];
  //     this.saveImage = file;
  //     console.log(this.saveImage);
  //       this.previewImage = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(file));

  //   }
  // }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    const fileSizeKB: number = Math.round(file.size / 1024); // Convert bytes to KB
    if (fileSizeKB > 5000) {
      this.fileInput.nativeElement.value = '';
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please select an image file up to 5MB in size.' })
      return;
    }
    if (!['image/jpeg', 'image/png'].includes(file.type)) {
      this.fileInput.nativeElement.value = '';
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please select a image.' })
      return;
    }
    if (file) {
      this.selectedFile = file;
      this.createImagePreview(file);
    }
  }

  createImagePreview(file: File): void {
    const reader = new FileReader();
    reader.onload = () => {
      this.previewImage = reader.result as string;
    };
    reader.readAsDataURL(file);
  }

  show() {
    console.log(this.selectedFile);
  }

  deleteImage(): void {
    if (this.selectedFile || this.previewImage) {

      console.log('Deleting file:', this.selectedFile?.name || 'existing image');
      this.selectedFile = null;
      this.previewImage = null; // Clear the image preview
      this.createProductForm.controls.ProductImage.setValue(null);
      this.fileInput.nativeElement.value = '';
    }
  }

  //   createProduct() {
  //     this.createProductForm.controls.ProductCode.setValue(this.createProductForm.controls.ProductCode.value);
  //     this.submitted = true;

  //     const isValid = this.validateForm();
  //     if (!isValid) {
  //       return;
  //     }

  //     if (!this.createProductForm.controls.HSNCode.value) {
  //       this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Please select HSN Code.' });
  //       this.activeIndex = 1;
  //       return;
  //     }

  //     const salesPrice = this.createProductForm.controls.SalesPrice.value;
  //     if (salesPrice === '' || salesPrice === null) {
  //       this.createProductForm.controls.SalesPrice.setValue(null);
  //     }

  //     const standardCost = this.createProductForm.controls.StandardCost.value;
  //     if (standardCost === '' || standardCost === null) {
  //       this.createProductForm.controls.StandardCost.setValue(null);
  //     }

  //     this.loader = true;

  //     var ProductCode = this.createProductForm.controls.ProductCode.value;
  //     this.createProductForm.controls.ProductCode.setValue(_.toString(ProductCode));

  //     if (!this.createProductForm.controls.ProductId.value) {
  //       this.createProductForm.controls.ProductId.setValue(0);
  //     }

  //     if (!this.createProductForm.controls.Weight.value) {
  //       this.createProductForm.controls.Weight.setValue(0);
  //     }
  // const colorValue: any = this.createProductForm.controls.ColorId.value;

  // if (typeof colorValue === 'number') {
  //   this.createProductForm.controls.ColorId.setValue(colorValue);
  // } else if (colorValue && colorValue.colorId) {
  //   this.createProductForm.controls.ColorId.setValue(colorValue.colorId);
  // } else {
  //   this.createProductForm.controls.ColorId.setValue(null);
  // }

  // // --- Handle GroupId ---
  // const groupValue: any = this.createProductForm.controls.GroupId.value;

  // if (typeof groupValue === 'number') {
  //   this.createProductForm.controls.GroupId.setValue(groupValue);
  // } else if (groupValue && groupValue.productGroupId) {
  //   this.createProductForm.controls.GroupId.setValue(groupValue.productGroupId);
  // } else {
  //   this.createProductForm.controls.GroupId.setValue(null);
  // }

  // // --- Handle SubCategoryId ---
  // const subCatValue: any = this.createProductForm.controls.SubCategoryId.value;

  // if (typeof subCatValue === 'number') {
  //   this.createProductForm.controls.SubCategoryId.setValue(subCatValue);
  // } else if (subCatValue && subCatValue.subCategoryId) {
  //   this.createProductForm.controls.SubCategoryId.setValue(subCatValue.subCategoryId);
  // } else {
  //   this.createProductForm.controls.SubCategoryId.setValue(null);
  // }

  //     this.inventoryService.createProduct(this.createProductForm.value).subscribe({
  //       next: (data: any) => {
  //         if (data.success === true) {
  //           this.loader = false;
  //           console.log(data);
  //           this.uploadImage(data.productId);
  //           this.messageService.add({ severity: 'success', summary: 'Success', detail: data.message });
  //           setTimeout(() => {
  //             this.router.navigate(['/home/listProducts']);
  //           }, 1000);
  //         } else {
  //           this.loader = false;
  //           this.messageService.add({ severity: 'error', summary: 'Failed', detail: data.message });
  //         }
  //       },
  //       error: error => {
  //         console.log(error);
  //         this.loader = false;
  //         this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Error while Creating Product' });
  //       }
  //     });
  //   }

  createProduct() {
    this.submitted = true;

    // Validate form
    if (!this.validateForm()) {
      return;
    }

    // Ensure required field HSNCode is selected
    if (!this.createProductForm.controls.HSNCode.value) {
      this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Please select HSN Code.' });
      this.activeIndex = 1;
      return;
    }

    const selectedColor = this.createProductForm.controls.Color.value;
    if (selectedColor && selectedColor.colorId) {
      this.createProductForm.controls.ColorId.setValue(selectedColor.colorId);
    } else {
      this.createProductForm.controls.ColorId.setValue(null);
    }
    // Normalize numeric fields
    const weight = this.createProductForm.controls.Weight.value;
    const salesPrice = this.createProductForm.controls.SalesPrice.value;
    const standardCost = this.createProductForm.controls.StandardCost.value;

    this.createProductForm.patchValue({
      Weight: weight || 0,
      SalesPrice: salesPrice ?? 0.00,
      StandardCost: standardCost ?? 0.00,

    });

    // Ensure ProductId is set
    if (!this.createProductForm.controls.ProductId.value) {
      this.createProductForm.controls.ProductId.setValue(0);
    }

    // Ensure ProductCode is a string
    const productCode = this.createProductForm.controls.ProductCode.value;
    this.createProductForm.controls.ProductCode.setValue(_.toString(productCode));

    // Normalize ColorId (ensure it's a number)
    const colorValue: any = this.createProductForm.controls.ColorId.value;
    if (typeof colorValue === 'object' && colorValue?.colorId) {
      this.createProductForm.controls.ColorId.setValue(colorValue.colorId);
    } else if (typeof colorValue !== 'number') {
      this.createProductForm.controls.ColorId.setValue(null);
    }

    // Normalize GroupId
    const groupValue: any = this.createProductForm.controls.GroupId?.value;
    if (typeof groupValue === 'object' && groupValue?.productGroupId) {
      this.createProductForm.controls.GroupId.setValue(groupValue.productGroupId);
    } else if (typeof groupValue !== 'number') {
      this.createProductForm.controls.GroupId.setValue(null);
    }

    // Normalize SubCategoryId
    const subCatValue: any = this.createProductForm.controls.SubCategoryId?.value;
    if (typeof subCatValue === 'object' && subCatValue?.subCategoryId) {
      this.createProductForm.controls.SubCategoryId.setValue(subCatValue.subCategoryId);
    } else if (typeof subCatValue !== 'number') {
      this.createProductForm.controls.SubCategoryId.setValue(null);
    }

    const rawFormValue = this.createProductForm.value;

    const payload = {
      ...rawFormValue,
      Color: undefined,
      ColorName: undefined,
      Vendor: undefined,
      Add: undefined,
      Group: undefined,
      SubCategory: undefined,
      CreatedBy: rawFormValue.CreatedBy ?? localStorage.getItem('username'),
    };

    // Optional: Confirm the final payload before sending
    console.log('Payload to send:', payload);

    this.loader = true;

    this.inventoryService.createProduct(payload).subscribe({
      next: (data: any) => {
        this.loader = false;

        if (data.success === true) {
          // Upload image if applicable
          if (this.selectedFile) {
            this.uploadImage(data.productId);
          }

          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: data.message,
          });

          setTimeout(() => {
            this.router.navigate(['/home/listProducts']);
          }, 1000);
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Failed',
            detail: data.message,
          });
        }
      },
      error: error => {
        this.loader = false;
        console.error('Error creating product:', error);

        this.messageService.add({
          severity: 'error',
          summary: 'Failed',
          detail: 'Error while Creating Product',
        });
      }
    });
  }


  uploadImage(productId: number) {
    if (this.selectedFile) {
      const formData = new FormData();
      formData.append('image', this.selectedFile);
      this.inventoryService.uploadImage(productId, formData).subscribe({
        next: (response: any) => {
          if (response.success) {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Image uploaded successfully.' });
          } else {
            this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Image upload failed.' });
          }
        },
      });
    }
  }


  cancel() {
    this.router.navigate(['/home/listProducts']);
  }

  // deleteImage(){
  //    this.previewImage = undefined;
  //   // window.location.reload()

  //   }

  GetImage(productId: number) {
    this.inventoryService.getImage(productId).subscribe({
      next: (response: any) => {
        try {
          const blob = new Blob([response], { type: 'image/jpeg' });
          const reader = new FileReader();
          reader.onload = () => {
            this.previewImage = reader.result as string;
            this.createProductForm.patchValue({
              ProductImage: null
            });
          };
          reader.readAsDataURL(blob);
        } catch (e) {
          console.error('Error processing image:', e);
        }
      },
      error: (error: any) => {
        console.error('HTTP error:', error);
      }
    });
  }

  setBase64Image(imageBase64: string) {
    this.previewImage = `data:image/jpeg;base64,${imageBase64}`;
  }


  EditProduct() {
    this.route.queryParams.subscribe(params => {
      try {
        this.editProductData = JSON.parse(params['productId']);

        if (this.editProductData) {
          this.loader = true;
          this.inventoryService.getProductById(this.editProductData).subscribe({
            next: (data: any) => {
              document.title = 'Update Product';
              this.loader = false;
              this.iseditProduct = true;
              const selectedColor = this.ColorDropdown.find(c => c.colorId === data.colorId);
              let selectedSubCategory = null;
              if (data.category?.subCategory?.length > 0) {
                selectedSubCategory = data.category.subCategory.find(
                  (sub: any) => sub.subCategoryId === data.subCategoryId
                );
              }
              this.createProductForm.patchValue({
                ProductId: data.productId,
                ProductCode: data.productCode,
                ProductName: data.productName,
                ProductImage: data.productImage,
                ProductDescription: data.productDescription,
                CanBePurchased: data.canBePurchased,
                CanBeRented: data.canBeRented,
                CanBeSold: data.canBeSold,
                isactive: data.isActive,
                gstRate: data.gstRate,
                make: data.make,
                mkfpartid: data.mkfpartid,
                productcomment: data.productcomment,
                IsTaxable: data.isTaxable,
                IsInventory: data.isInventory,
                isLocationTracking: data.isLocationTracking,
                isLotTracking: data.isLotTracking,
                isSerialTracking: data.isSerialTracking,
                ProductType: data.productType,
                UOM: data.unitsofMeasures,
                UnitsOfMeasure: data.unitsOfMeasure,
                UnitsofMeasureId: data.unitsofMeasureId,
                PurchasingUom: data.purchasingUom,
                SellingUom: data.sellingUom,
                SalesPrice: data.salesPrice,
                StandardCost: data.standardCost,
                Weight: data.weight,
                CategoryValue: data.category ?? null,
                CategoryId: data.categoryId ?? null,
                HSNCode: data.hsnCode,
                GSTId: data.gstId,
                producttypedropdown: data.productType,
                Barcode: data.barcode,
                CostCalculation: data.costCalculation,
                ProductSpecification: data.productSpecification,
                ProductSize: data.productSize,
                Color: selectedColor ?? null,
                ColorId: data.colorId,
                ColorName: data.color ? data.color.colorName : '',
                VendorProductCode: data.vendorProductCode,
                StandardType: data.standardType,

                VendorId: data.vendor ? data.vendor.vendorId : null,
                VendorName: data.vendor ? data.vendor.vendorName : '',
                VendorCode: data.vendor ? data.vendor.vendorCode : '',
                AddressId: data.vendor ? data.vendor.addressId : null,
                Add: data.vendor?.address ? `${data.vendor.address.addressLine1}, ${data.vendor.address.city}, ${data.vendor.address.state}, ${data.vendor.address.country}, ${data.vendor.address.zip}` : '',
                IsServiceType: data.isServiceType,
                GroupId: data.groupId,
                SubCategoryId: selectedSubCategory?.subCategoryId ?? null,
                ProductGroupName: data.productGroups?.productGroupName ?? '',
                SubCategoryName: selectedSubCategory ?? null
              });
              this.createProductForm.get('IsServiceType')?.disable();

              // console.log('Patched form data:', this.createProductForm.value);
              this.getProductTypeNameByCode(data.productType);
              if (data.productImage) {
                this.setBase64Image(data.productImage);
              }
            },

            error: error => {
              console.error('Error fetching product:', error);
              this.loader = false;
            }
          });
        }
        this.createProductForm.controls.UpdatedBy.setValue(localStorage.getItem('username'));
      } catch (error) {
        // console.error('Error parsing product data:', error);
        this.manualEntry();
      }
    });
  }


  updateProduct() {
    this.submitted = true;

    if (this.createProductForm.invalid) {
      this.createProductForm.markAllAsTouched();
      return;
    }

    this.loader = true;

    if (!this.createProductForm.controls.Weight.value) {
      this.createProductForm.controls.Weight.setValue(0);
    }

    const selectedColor: Color | null = this.createProductForm.get('Color')?.value ?? null;

    this.createProductForm.patchValue({
      ColorId: selectedColor ? selectedColor.colorId : null,
      ColorName: selectedColor ? selectedColor.colorName : null
    });

    const originalProduct = this.editProductData || {};


    let isServiceType = this.createProductForm.get('IsServiceType')?.value;


    const payload = {
      ...originalProduct,
      ...this.createProductForm.value,
      IsServiceType: isServiceType
    };


    this.inventoryService.updateProduct(payload).subscribe({
      next: (data: any) => {
        this.loader = false;

        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Product updated successfully.'
        });

        if (this.selectedFile) {
          this.uploadImage(data);
        }

        setTimeout(() => {
          this.router.navigate(['/home/listProducts']);
        }, 1000);
      },
      error: (error: any) => {
        this.loader = false;
        console.error('Error updating product', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to update product.'
        });
      }
    });
  }

  getUOM() {
    this.administratorService.getAllUnitsOfMeasure(this.pageRequest).subscribe({
      next: (data: any) => {
        // console.log(data.unitsofMeasures);
        this.UOMDropdown = data.unitsofMeasures;
      },
      error: error => {
        console.log(error);
      }
    });
  }

  filterUOM(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.UOMDropdown as any[]).length; i++) {
      let uom = (this.UOMDropdown as any[])[i];
      if (uom.unitsofMeasureCode.toLowerCase().indexOf(query.toLowerCase()) == 0 ||
        uom.unitsofMeasure.toLowerCase().indexOf(query.toLowerCase()) === 0) {
        filtered.push(uom);
      }
    }

    this.filteruom = filtered;
  }

  setUOM(event: any) {
    if (event.value) {
      this.createProductForm.controls.UnitsofMeasureId.setValue(event.value.unitsofMeasureId);
      this.createProductForm.controls.UnitsOfMeasure.setValue(_.toString(event.value.unitsofMeasure));
      this.createProductForm.controls.PurchasingUom.setValue(_.toString(event.value.unitsofMeasure));
      this.createProductForm.controls.SellingUom.setValue(_.toString(event.value.unitsofMeasure));
    }
  }


  setSellingUOM(event: any) {
    if (event.value) {
      this.createProductForm.patchValue({
        SellingUom: event.value.unitsofMeasure,
        //SellingUomId: event.value.unitsofMeasureId
      });
    }
  }

  setPurchasingUOM(event: any) {
    if (event.value) {
      this.createProductForm.patchValue({
        PurchasingUom: event.value.unitsofMeasure,
        //PurchasingUomId: event.value.unitsofMeasureId
      });
    }
  }


  setCategory(event: any) {
    if (event.value) {
      const selectedCategoryId = event.value.categoryId;
      this.createProductForm.controls.CategoryId.setValue(selectedCategoryId);
      this.filterProductGroups = this.ProductSubCategoryDropdown.filter(
        (sub: any) => sub.categoryId === selectedCategoryId
      );
    }
  }


  resetForm() {
    this.resetClicked = true;
    this.createProductForm.reset();
    this.createProductForm.controls.isactive.setValue(true);
    this.createProductForm.controls.IsTaxable.setValue(true);
    this.createProductForm.controls.IsInventory.setValue(true);
    this.createProductForm.controls.manualEntry.setValue(false);
    // this.createProductForm.controls.ProductId.setValue(null);
    this.createProductForm.controls.StandardCost.setValue(0);
    this.createProductForm.controls.SalesPrice.setValue(0);
    this.manualEntry();
    this.submitted = false;
    setTimeout(() => {
      this.resetClicked = false;
    }, 500);
  }

  getProductType() {
    this.inventoryService.getProductType().subscribe({
      next: (data: any) => {
        this.ProductTypeDropdown = data.productType;
      },
      error: error => {
        console.log(error);
      }
    });
  }

  getCatagory() {
    this.inventoryService.getCatagory().subscribe({
      next: (data: any) => {
        this.CategoryDropdown = data.category;
      },
      error: error => console.log(error)
    });
  }

  filterCatagory(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.CategoryDropdown as any[]).length; i++) {
      let productType = (this.CategoryDropdown as any[])[i];
      if (productType.categoryName.toLowerCase().indexOf(query.toLowerCase()) == 0 ||
        productType.categoryCode.toLowerCase().indexOf(query.toLowerCase()) === 0) {
        filtered.push(productType);
      }
    }

    this.filterCategorys = filtered;
  }

  // setProductType(data: any) {
  //   if (data.value) {
  //     const productCode = _.toString(data.value.productTypeCode);
  //     this.createProductForm.controls.ProductType.setValue(productCode);
  //     // this.getProductTypeNameByCode(productCode);
  //     if (!this.createProductForm.controls.manualEntry.value) {
  //       this.getManualEntry();
  //     }
  //   }
  // }

  setProductType(data: any) {
    if (!data?.value) return;

    const productType = data.value;

    this.createProductForm.patchValue({
      ProductType: productType.productTypeCode,
      ProductPrefix: productType.productTypePrefix
    });

    if (this.isAutoProductCodeEnabled) {
      this.getAutoProductCode(productType.productTypePrefix);
    }
  }



  getAutoProductCode(prefix: string) {
    //this.loader = true;

    this.inventoryService.getautogenerateProductCodeNext(prefix).subscribe({
      next: (res: any) => {
        this.createProductForm.patchValue({
          ProductCode: res.productCode
        });
      },
      error: () => {
        this.loader = false;
      }
    });
  }


  getProductTypeNameByCode(productTypeCode: string): void {
    if (!productTypeCode) {
      this.createProductForm.controls['producttypedropdown'].setValue('Invalid code');
      return;
    }

    this.inventoryService.getProductByType(productTypeCode).subscribe({
      next: (data: any[]) => {
        if (Array.isArray(data) && data.length > 0) {
          const productType = data[0];
          const name = productType?.productTypeName || 'Unknown';
          this.createProductForm.controls['producttypedropdown'].setValue(name);
        } else {
          this.createProductForm.controls['producttypedropdown'].setValue('Unknown');
        }
      },
      error: (error: any) => {
        console.error('Error fetching product type name:', error);
        this.createProductForm.controls['producttypedropdown'].setValue('Error fetching name');
      }
    });
  }

  filterProductType(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.ProductTypeDropdown as any[]).length; i++) {
      let productType = (this.ProductTypeDropdown as any[])[i];
      if (productType.productTypeCode.toLowerCase().indexOf(query.toLowerCase()) == 0 ||
        productType.productTypeName.toLowerCase().indexOf(query.toLowerCase()) === 0) {
        filtered.push(productType);
      }
    }

    this.filterproducttype = filtered;
  }

  getGSTList() {
    const type = this.createProductForm.get('IsServiceType')?.value;

    if (type === null || type === undefined) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Validation',
        detail: 'Please select Type (Goods or Service) first.'
      });
      return;
    }
    let typeBoolean: boolean;
    if (type === false) {
      typeBoolean = false;
    } else if (type === true) {
      typeBoolean = true;
    } else {
      this.messageService.add({
        severity: 'warn',
        summary: 'Validation',
        detail: 'Please select Type (Goods or Service) first.'
      });
      return;
    }

    this.ref = this.dialogService.open(GstListLookupComponent, {
      header: 'GST List',
      width: '60%',
      data: { type: typeBoolean }
    });

    this.ref.onClose.subscribe((data: GSTInfo) => {
      if (data) {
        this.createProductForm.controls.HSNCode.setValue(data.hsnCode);
        this.createProductForm.controls.GSTId.setValue(_.toNumber(data.gstId));
        const isTaxable = data.gstRate > 0;
        this.createProductForm.controls.IsTaxable.setValue(isTaxable);
        this.createProductForm.controls.gstRate.setValue(data.gstRate);
      }
    });
  }





  showInventoryStatus() {
    const productCode = this.createProductForm.controls.ProductCode.value;
    const productName = this.createProductForm.controls.ProductName?.value;

    this.ref = this.dialogService.open(InventoryStatusLookupComponent, {
      header: `Inventory Status for Product Code: ${productCode} - ${productName}`,
      width: '80%',
      data: { ProductCode: productCode }
    });
  }

  showLedger() {
    const productCode = this.createProductForm.controls.ProductCode.value;
    const productName = this.createProductForm.controls.ProductName?.value;
    const productId = this.createProductForm.controls.ProductId.value;

    this.ref = this.dialogService.open(LedgerLookupComponent, {
      header: `Ledger Card for Product Code: ${productCode} - ${productName}`,
      width: '80%',
      data: { ProductCode: productCode, ProductId: productId }
    });
  }

  showLocations() {
    const productCode = this.createProductForm.controls.ProductCode.value;
    const productName = this.createProductForm.controls.ProductName?.value;
    const productId = this.createProductForm.controls.ProductId.value;
    const productDescription = this.createProductForm.controls.ProductDescription?.value;
    const uom = this.resolveUomLabel(
      this.createProductForm.controls.UnitsOfMeasure?.value
      || this.createProductForm.controls.UOM?.value
      || this.createProductForm.controls.SellingUom?.value
      || this.createProductForm.controls.PurchasingUom?.value
    );

    this.ref = this.dialogService.open(ProductLocationsLookupComponent, {
      header: `Locations for Product Code: ${productCode} - ${productName || productDescription || ''}`,
      width: '85%',
      contentStyle: { overflow: 'auto' },
      data: {
        ProductId: productId,
        ProductCode: productCode,
        ProductName: productName,
        ProductDescription: productDescription,
        UOM: uom
      }
    });
  }

  private resolveUomLabel(value: any): string {
    if (!value) return '';
    if (typeof value === 'string') return value;
    return value.unitsofMeasure
      || value.unitsofMeasureCode
      || value.UnitsofMeasure
      || value.UnitsofMeasureCode
      || '';
  }
  onKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.moveToNextField(event);
    }
  }

  moveToNextField(event: KeyboardEvent) {
    const inputs = Array.from(document.querySelectorAll('input')) as HTMLInputElement[];
    const index = inputs.indexOf(event.target as HTMLInputElement);
    if (index > -1 && index < inputs.length - 1) {
      (inputs[index + 1] as HTMLInputElement).focus();
    }
  }
  focusNextInput(event: Event): void {
    const keyboardEvent = event as KeyboardEvent;
    keyboardEvent.preventDefault(); // Prevent form submission on Enter key press

    const target = keyboardEvent.target as HTMLElement;
    const formElements = Array.from((target.closest('form') as HTMLFormElement).elements) as HTMLElement[];
    const index = formElements.indexOf(target);

    if (index > -1 && index < formElements.length - 1) {
      const nextElement = formElements[index + 1];
      nextElement.focus();
    }
  }
  getVendor() {
    this.ref = this.dialogService.open(VendorLookupComponent, {
      header: 'Vendor List',
      width: '60%',
    });
    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        this.createProductForm.patchValue({
          VendorName: data.vendorName,
          VendorId: data.vendorId,
          VendorCode: data.vendorCode,
          AddressId: data.addressId,
          Add: `${data.address.addressLine1},${data.address.city} ${data.address.state}, ${data.address.country},${data.address.zip}`
        });
        this.vendorState = data.address.state;
        this.selectedCustomerEmail = data.email;
        this.selectedCustomerName = data.vendorName;
      }
    });
  }

  // getSystemConfigData(): void {
  //   this.loader = true;
  //   const appKey = 'hide.columns_Products';

  //   this.inventoryService.getSystemConfigByAppKey(appKey).subscribe({
  //     next: (response: any) => {
  //       this.loader = false;
  //       if (response.appKeycode === appKey) {
  //         this.hide = response.data === 'N';
  //       }
  //     },
  //     error: error => {
  //       console.error('Error fetching System Config Data:', error);
  //       this.loader = false;
  //     }
  //   });
  // }

  standardTypes = [
    { id: 1, StandardType: 'Standard' },
    { id: 2, StandardType: 'Non Standard' }
  ];

  filterStandardtype = this.standardTypes;

  setstandardtype(event: any) {
    if (event.value) {
      this.createProductForm.controls.StandardType.setValue(event.value.StandardType); // Just the string
    }
  }

  filterstandardtype(event: any) {
    const query = event.query.toLowerCase();
    this.filterStandardtype = this.standardTypes.filter(item =>
      item.StandardType.toLowerCase().includes(query)
    );
  }

  // ADD NEW FIELDS


  // getColor() {
  //     this.administratorService.getAllColour(this.pageRequest).subscribe({
  //       next: (data: any) => {
  //         // console.log(data.unitsofMeasures);
  //         this.ColorDropdown = data.color;
  //       },
  //       error: error => {
  //         console.log(error);
  //       }
  //     });
  //   }


  // filterColor(event: any) {
  //   let filtered: any[] = [];
  //   let query = event.query;

  //   for (let i = 0; i < (this.ColorDropdown as any[]).length; i++) {
  //     let color = (this.ColorDropdown as any[])[i];
  //     if (color.colorCode.toLowerCase().indexOf(query.toLowerCase()) == 0  ||
  //     color.color.toLowerCase().indexOf(query.toLowerCase()) === 0) {
  //       filtered.push(color);
  //     }
  //   }

  //   this.filtercolor = filtered;
  // }

  //    getColor(): Promise<void> {
  //   return new Promise((resolve, reject) => {
  //     this.administratorService.getAllColors().subscribe({
  //       next: (data: Color[]) => {
  //         this.ColorDropdown = data;
  //         resolve();
  //       },
  //       error: error => {
  //         console.error('Error fetching colors:', error);
  //         reject(error);
  //       },
  //     });
  //   });
  // }

  // filterColors(event: any) {
  //   const query = event.query.toLowerCase();
  //   this.filteredColors = this.ColorDropdown.filter(color =>
  //     color.colorName?.toLowerCase().includes(query)
  //   );
  // }

  // setColor(event: any) {
  //   if (event) {
  //     this.createProductForm.controls.ColorName.setValue(event.colorName);

  //   }
  // }
  // get product group

  getProductGroups() {
    this.administratorService.getAllProductGroups(this.pageRequest).subscribe({
      next: (data: any) => {
        this.ProductGroupsDropdown = data.productGroups;
      },
      error: error => {
        console.log(error);
      }
    });
  }

  // filterProductGroup(event: any) {
  //   let filtered: any[] = [];
  //   let query = event.query;

  //   for (let i = 0; i < (this.ProductGroupsDropdown as any[]).length; i++) {
  //     let ProductGroups = (this.ProductGroupsDropdown as any[])[i];
  //     if (ProductGroups.productGroupName.toLowerCase().indexOf(query.toLowerCase()) == 0  ||
  //     ProductGroups.ProductGroups.toLowerCase().indexOf(query.toLowerCase()) === 0) {
  //       filtered.push(ProductGroups);
  //     }
  //   }

  //   this.filterProductGroups = filtered;
  // }
  filterProductGroup(event: any) {
    const query = event.query.toLowerCase();

    this.filterProductGroups = this.ProductGroupsDropdown.filter(pg =>
      pg.productGroupName.toLowerCase().includes(query)
    );
  }


  setProductGroups(event: any) {
    if (event?.value?.productGroupName) {
      this.createProductForm.controls.ProductGroupName.setValue(event.value.productGroupName);
      this.createProductForm.controls.GroupId.setValue(event.value.productGroupId);
    }
  }

  getProductSubCategory() {
    this.inventoryService.getCatagory().subscribe({
      next: (data: any) => {
        this.ProductSubCategoryDropdown = data.category.flatMap((cat: any) => cat.subCategory || []);
      },
      error: error => console.log(error)
    });
  }

  filterSubCategory(event: any) {
    const query = event.query.toLowerCase();
    const selectedCategoryId = this.createProductForm.controls.CategoryId.value;
    const selectedCategory = this.CategoryDropdown.find(
      (cat: any) => cat.categoryId === selectedCategoryId
    );

    if (!selectedCategory || !selectedCategory.subCategory) {
      this.filterCategorys = [];
      return;
    }

    this.filterCategorys = selectedCategory.subCategory.filter((sub: any) =>
      sub.subCategoryName?.toLowerCase().includes(query) ||
      sub.subCategoryCode?.toLowerCase().includes(query)
    );
  }



  setProductSubCategory(event: any) {
    if (event.value) {
      this.createProductForm.controls.SubCategoryName.setValue(event.value.subCategoryName);
      this.createProductForm.controls.SubCategoryId.setValue(event.value.subCategoryId);
    }
  }

  filtersCatagory(event: any) {
    const query = event.query.toLowerCase();
    const selectedProductGroupName = this.createProductForm.controls.ProductGroupName.value;

    if (!selectedProductGroupName) {
      this.filterCategorys = [];
      return;
    }

    this.administratorService.getGroupByName(selectedProductGroupName).subscribe((response: any) => {
      const selectedProductGroupId = response?.productGroupId;

      if (!selectedProductGroupId) {
        this.filterCategorys = [];
        return;
      }

      const productGroup = (this.ProductGroupsDropdown as any[]).find(pg => pg.productGroupId === selectedProductGroupId);

      if (!productGroup || !Array.isArray(productGroup.category)) {
        this.filterCategorys = [];
        return;
      }

      this.filterCategorys = productGroup.category.filter((category: any) => {
        return category.categoryName?.toLowerCase().startsWith(query) ||
          category.categoryCode?.toLowerCase().startsWith(query);
      });
    });
  }
  onTypeChange() {

    const type = this.createProductForm.get('IsServiceType')?.value;

    if (type === null || type === undefined) return;

    if (type === false) {
      this.filteredHSNCodes = this.allHSNCodes.filter(hsn => hsn.IsService === 0);
    } else {
      this.filteredHSNCodes = this.allHSNCodes.filter(hsn => hsn.IsService === 1);
    }

    const selectedHSN = this.createProductForm.get('HSNCode')?.value;
    if (selectedHSN) {
      const match = this.filteredHSNCodes.find(h => h.HSNCode === selectedHSN);
      if (!match) {
        this.createProductForm.get('HSNCode')?.setValue(null);
      }
    }
  }

}


